import React from 'react';

const Hamburger = () => {
  return (
    <nav className="header__right-item" tabIndex="3">
      <div />
      <div />
      <div />
    </nav>
  );
};

export default Hamburger;